import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {withRouter} from 'react-router';
import styled from 'styled-components';
import {Table} from 'semantic-ui-react';
import {retrieveTeam, retrieveTeamUsers} from '../../api';
import MenuButton from '../../components/Button/MenuButton';
import {BlueContainer, BLUE, LIGHT_BLUE} from '../../components/Container/ContainerMix';
import {getUserProperty, getUserPropertyWithRefresh} from '../../util/Session';

const LeaderboardHeader = styled(BlueContainer)`
  min-height: 224px;
  color: #FFFFFF;
  justify-content: start;
  text-align: center;
  & > h3 {
    font-size: 18px;
  }
  background-size: calc(130vw) calc(110vw),calc(110vw) calc(130vw),auto;
  display: flex;
  flex-direction: row;
  padding: 10px;
`;

const TeamNumbers = styled.div`
  flex: 1;
  color: rgba(255,255,255,.75);
  font-size: 12px;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding-bottom: 25px;
  & span {
    font-size: 32px;
    font-weight: bold;
    margin-bottom: 10px;
  }
`;

const IconWrapper = styled.div`
  width: 40px;
  height: 40px;
  position: absolute;
  bottom: 45px;
  left: 46px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  background-color: #ffffff;
`;


const TeamPlace = styled.div`
  font-size: 68px;
  width: 140px;
  height: 140px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: row;
  background-color: transparent;
  border: 4px solid #ffffff;
  border-radius: 50%;
  margin-bottom: 35px;
  text-shadow: 0px 3px 6px rgba(0,0,0,.3);
  & span {
    font-size: 40px;
    margin-top: -20px;
  }
`;

const TeamPlaceWrapper = styled.div`
  width: 140px;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  font-size: 24px;
  font-weight: bold;
  position: relative;
  &.place1 {
    & ${TeamPlace} {
      background-color: #EBBB2D;
      border: 4px solid #FFD93F;
    }
    & ${IconWrapper} {
      background-color: #FFD93F;
      svg {
        fill: #EBBB2D;
      }
    }
  }
  &.place2 {
    & ${TeamPlace} {
      background-color: #828282;
      border: 4px solid #D4D4D4;
    }
    & ${IconWrapper} {
      background-color: #D4D4D4;
      svg {
        fill: #828282;
      }
    }
  }
  &.place3 {
    & ${TeamPlace} {
      background-color: #CD9143;
      border: 4px solid #FFBF6A;
    }
    & ${IconWrapper} {
      background-color: #FFBF6A;
      svg {
        fill: #CD9143;
      }
    }
  }
`;


const Icon = styled.svg`
  width: 100%;
  height: 21px;
  text-align: center;
`;

const Wrapper = styled.div`
  height: calc(100vh - 86px);
  position: unset;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
`;

const Flex = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const FlexWithPadding = styled(Flex)`
  padding: 0px 10px;
  height: 86px;
  justify-content: flex-start;
  background-color: ${BLUE}
`;

const Title = styled.h5`
  color: rgba(255, 255, 255, 1);
  min-width: 150px;
  font-family: Roboto;
  cursor: pointer;
  padding: 9px 0;
`;

const Logo = styled.img`
  max-width: 35px;
  max-height: 35px;
  padding: 0 5px 0 0;
`;

const MenuText = styled.span`
  display: flex;
  flex: 1;
  justify-content: center;
  margin-right: 46px;
`;

const TableWrapper = styled.div`
  padding: 21px;
  background-color: #f6f6f6
  position: relative;
  padding-bottom: 100px;
`;

// Rank Table Style
// Since this table use is exclusive to Team Ranking
// all CSS remain in this document

const CellStyled = styled.div`
  background-color: ${props => props.isYou ? LIGHT_BLUE : '#eeeeee'};
  color: ${props => props.isYou ? '#ffffff' : '#000000'};
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

const RankTable = styled(Table)`
  &.ui.table {
    background-color: transparent;
    margin-top: 15px;
    border: none;
    font-size: 12px
    font-weight: bold;    
    & thead {
      font-size: 10px;
      & th {
        background: transparent;
        color: rgba(0, 0, 0, 0.87);
        padding: 10px 15px 0px 5px;
        font-weight: normal;
        border-bottom: none;
      }
    }
    & tbody {
      & tr {
        & td {
          padding: 5px 0;
        }
        & td:first-child {
          ${CellStyled} {
            border-radius: 20px 0 0 20px;
          }
        }
        & td:last-child {
          ${CellStyled} {
            border-radius: 0 20px 20px 0;
            padding-right: 20px;
            justify-content: flex-end;
          }
        }
      }
    }
    & tbody + tbody {
      & tr:first-child{
        & td {
          border-top: none;
        }
      }
    }

  } 
`;

const PlaceContainer = styled.span`
  width: 33px;
  height: 33px;
  background-color: transparent;
  border: 2px solid transparent;
  border-radius: 50%;
  margin-left: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 12px;
  &.place1 {
    background-color: #EBBB2D;
    border-color: #FFD93F;
  }
  &.place2 {
    background-color: #828282;
    border-color: #D4D4D4;
  }
  &.place3 {
    background-color: #CD9143;
    border-color: #FFBF6A;
  }
  &.place1, &.place2, &.place3 {
    color: #ffffff;
  }
`;


// END Rank Table Style
class Leaderboard extends Component {
  constructor() {
    super();
    this.state = {
      currentUserId: getUserProperty('id'),
      team: {},
      teamUsers: []
    };
  }

  componentDidMount() {
    return getUserPropertyWithRefresh('team_id')
      .then(teamId => retrieveTeam(teamId)
        .then(response => this.setState({team: response.data}))
        .then(() => retrieveTeamUsers(teamId))
        .then(response => this.setState({teamUsers: response.data})));
  }

  onTitleClick = () => {
    const {router} = this.props;
    router.push('/dashboard');
  };

  toOrdinalSuffix = num => {
    // eslint-disable-next-line radix
    const int = parseInt(num);

      
    const digits = [int % 10, int % 100];

      
    const ordinals = ['st', 'nd', 'rd', 'th'];

      
    const oPattern = [1, 2, 3, 4];

      
    const tPattern = [11, 12, 13, 14, 15, 16, 17, 18, 19];
    return oPattern.includes(digits[0]) && !tPattern.includes(digits[1])
      ? ordinals[digits[0] - 1]
      : ordinals[3];
  };

  render() {
    const {team, teamUsers, currentUserId} = this.state;
    const {onClickSidebar} = this.props;

    const teamPoints = teamUsers.reduce((sum, teamUser) => sum + teamUser.user.points, 0);

    return (
      <div>
        <FlexWithPadding>
          <MenuButton onClick={onClickSidebar}/>
          <MenuText>
            <Logo src="images/mark-white.svg" alt="Logo" />
            <Title onClick={this.onTitleClick}>My BodyBank Account</Title>
          </MenuText>
        </FlexWithPadding>
        <Wrapper>
          <LeaderboardHeader>
            <TeamNumbers><span>{team.num_teams}</span>Total teams</TeamNumbers>
            <TeamPlaceWrapper className={`place${team.rank}`}>
              <TeamPlace>
                {team.rank}
                <span>{this.toOrdinalSuffix(team.rank)}</span>
              </TeamPlace>Team rank
              <IconWrapper>
                <Icon viewBox="0 0 23.45 21.5">
                  <path d="M13.1,16.61c.49-3.86,5.46-7,5.46-16.61H4.89c0,9.58,5,12.75,5.47,16.61ZM9.57,5.4,11,5.2l.63-1.3.63,1.3,1.42.2-1,1,.26,1.42-1.27-.68-1.27.68.25-1.42Zm-3.72,4c.28.63.58,1.2.87,1.75C2.74,9.86.36,6,0,2H4c0,.47.08.94.14,1.38H1.49A8.7,8.7,0,0,0,5.85,9.43Zm9.78,10.72V21.5H7.82V20.15c1.9,0,2.31-1.4,2.51-2.56h2.8c.19,1.16.55,2.56,2.5,2.56ZM23.45,2c-.36,4-2.75,7.91-6.72,9.22.29-.53.59-1.11.87-1.74A8.7,8.7,0,0,0,22,3.32H19.33c.06-.44.1-.9.14-1.37Z"/>
                </Icon>
              </IconWrapper>
            </TeamPlaceWrapper>
            <TeamNumbers><span>{teamPoints}</span>Points</TeamNumbers>
          </LeaderboardHeader>
          <TableWrapper>
            <h3>My Team Leaderboard</h3>
            <RankTable unstackable>
              <Table.Header>
                <Table.Row>
                  <Table.HeaderCell>Ranking</Table.HeaderCell>
                  <Table.HeaderCell>Name</Table.HeaderCell>
                  <Table.HeaderCell>Points</Table.HeaderCell>
                </Table.Row>
              </Table.Header>

              {teamUsers.map((teamUser, index) => (
                <Table.Body key={teamUser.user.id}>
                  <Table.Row>
                    <Table.Cell>
                      <CellStyled isYou={teamUser.user.id === currentUserId}>
                        <PlaceContainer className={`place${index + 1}`}>
                          {index + 1}
                          <span>{this.toOrdinalSuffix(index + 1)}</span>
                        </PlaceContainer>
                      </CellStyled>
                    </Table.Cell>
                    <Table.Cell>
                      <CellStyled isYou={teamUser.user.id === currentUserId}>{teamUser.user.id === currentUserId ? 'YOU' : `${teamUser.user.first_name} ${teamUser.user.last_name}`}</CellStyled>
                    </Table.Cell>
                    <Table.Cell>
                      <CellStyled isYou={teamUser.user.id === currentUserId}>{teamUser.user.points}</CellStyled>
                    </Table.Cell>
                  </Table.Row>
                </Table.Body>
              ))}
            </RankTable>
          </TableWrapper>
        </Wrapper>
      </div>
    );
  }
}

Leaderboard.propTypes = {
  onClickSidebar: PropTypes.func.isRequired,
  router: PropTypes.object.isRequired
};

export default withRouter(Leaderboard);



// WEBPACK FOOTER //
// ./src/pages/Team/Leaderboard.js